/**
 * Call bet slip helpers — separate limit-order call bets from buy-points (immediate) bets.
 */

export function isCallBetSlipItem(item) {
  if (!item) return false;
  return item.isCallBetMode === true || item.isCallBetType === true || item.isCallBetType === "true";
}

export function resolveDesiredCallBetPrice(item) {
  if (!item) return null;
  const raw = item.desiredPrice ?? item.customizedPrice ?? item.price;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function resolveDesiredCallBetPoint(item) {
  if (!item) return null;
  const raw = item.customizedPoint ?? item.desiredPoint ?? item.point;
  if (raw === undefined || raw === null || raw === "" || raw === "-") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function syncCallBetFlags(item) {
  if (!item || !isCallBetSlipItem(item)) {
    return {
      ...item,
      isCallBetMode: false,
      isCallBetType: "false",
      buyPoints: Number(item?.buyPoints) || 0,
    };
  }

  const isH2h = item.type === "h2h";
  const bookPrice = Number(item.bookPrice ?? item.originalPrice ?? item.price);
  const bookPoint = Number(item.originalPoint ?? item.point);

  if (isH2h) {
    const desiredPrice = resolveDesiredCallBetPrice(item);
    const active =
      Number.isFinite(desiredPrice) &&
      Number.isFinite(bookPrice) &&
      desiredPrice !== bookPrice;

    return {
      ...item,
      isCallBetMode: true,
      isCallBetType: active ? "true" : "false",
      desiredPrice: desiredPrice ?? bookPrice,
      bookPrice,
      buyPoints: 0,
      customizedPoint: item.point,
    };
  }

  const desiredPoint = resolveDesiredCallBetPoint(item);
  const active =
    Number.isFinite(desiredPoint) &&
    Number.isFinite(bookPoint) &&
    desiredPoint !== bookPoint;

  return {
    ...item,
    isCallBetMode: true,
    isCallBetType: active ? "true" : "false",
    customizedPoint: desiredPoint ?? bookPoint,
    bookPoint,
    buyPoints: 0,
  };
}

/** Buy-points dropdown must never create a pending call bet. */
export function applyBuyPointsSelection(row, selection, basePoint) {
  const base = Number(basePoint ?? row.originalPoint ?? row.point);
  const next = { ...row };
  next.point = selection.point;
  next.price = selection.price;
  next.customizedPoint = selection.point;
  next.buyPoints =
    Number.isFinite(base) && Number.isFinite(Number(selection.point))
      ? Math.round(Math.abs(Number(selection.point) - base) * 100) / 100
      : 0;
  next.isCallBetMode = false;
  next.isCallBetType = "false";
  return next;
}
